webpackJsonp([1],{

/***/ "/zTL":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./ai_gallery.jpg": "1ZYH",
	"./cdg.png": "PhY9",
	"./cloudyBay.png": "Y2H9",
	"./dewitt.jpg": "Go6I",
	"./diorUltraGlossApp.jpg": "ynRJ",
	"./diptyque_unleash.png": "5CU0",
	"./ecoleMultimedia2.jpg": "tzh/",
	"./keakr.jpg": "S684",
	"./mechant.jpg": "Pl3I",
	"./montblanc_haus.png": "q2qx",
	"./natixis_intranet.png": "yafy",
	"./printemps.jpg": "kNu9",
	"./ultranoirv4.jpg": "bNfy",
	"./vipping.jpg": "Vl6e",
	"./vrUltranoir.jpg": "WIpY"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/zTL";

/***/ }),

/***/ "1ZYH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ai_gallery.6b3f397.jpg";

/***/ }),

/***/ "5CU0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/diptyque_unleash.6df0bfc.png";

/***/ }),

/***/ "A4Sc":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/resume_rousseau_kevin_en.44b6bad.pdf";

/***/ }),

/***/ "CUSo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cidb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Go6I":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dewitt.49d49cb.jpg";

/***/ }),

/***/ "I2Ij":
/***/ (function(module, exports) {

module.exports = [{
    "title": "Studio#Mechant.tv",
    "fullImage": "mechant.jpg",
    "tags": ["Nuxt", "Three.js"],
    "url": "https://www.mechant.tv/",
    "year": "2023",
    "agency": "ultranoir",
    "agencyUrl": "http://www.ultranoir.com/",
    "awards": []
}, {
    "title": "AI#Gallery",
    "fullImage": "ai_gallery.jpg",
    "tags": ["Nuxt", "Three.js"],
    "url": "https://ai-gallery.ultranoir.com/",
    "year": "2023",
    "agency": "ultranoir",
    "agencyUrl": "http://www.ultranoir.com/",
    "awards": [{
        "type": "FWA",
        "name": "Site of the day",
        "date": "23/02/2023"
    }]
}, {
    "title": "Keakr#Corporate",
    "fullImage": "keakr.jpg",
    "tags": ["Nuxt", "Strapi"],
    "url": "https://corporate.keakr.io/",
    "year": "2022",
    "agency": "ultranoir",
    "agencyUrl": "http://www.ultranoir.com/",
    "awards": []
}, {
    "title": "Moët Hennesy#Cloudy bay",
    "fullImage": "cloudyBay.png",
    "tags": ["React", "Gatsby", "Drupal 8"],
    "url": "https://www.ultranoir.com/fr/projets/cloudybayconz-1536.html",
    "year": "2022",
    "agency": "ultranoir",
    "agencyUrl": "http://www.ultranoir.com/",
    "awards": []
}, {
    "title": "Montblanc#Haus",
    "fullImage": "montblanc_haus.png",
    "tags": ["HTML5", "CSS3", "JavaScript"],
    "url": "https://www.ultranoir.com/fr/projets/montblanc-haus-1539.html",
    "year": "2022",
    "agency": "ultranoir",
    "agencyUrl": "http://www.ultranoir.com/",
    "awards": []
}, {
    "title": "Diptyque#Unleash the Rose",
    "fullImage": "diptyque_unleash.png",
    "tags": ["HTML5", "CSS3", "JavaScript", "Nuxts.js", "Vue.js"],
    "url": "https://www.ultranoir.com/fr/projets/unleash-the-rose-1530.html",
    "year": "2022",
    "agency": "ultranoir",
    "agencyUrl": "http://www.ultranoir.com/",
    "awards": []
}, {
    "title": "Self#Scenter<span>(Comme des Garçons Parfums)</span>",
    "fullImage": "cdg.png",
    "tags": ["JavaScript", "Three.js", "Shaders", "Node.js", "GSAP", "SASS"],
    "url": "http://self-scenter.comme-des-garcons-parfum.com/",
    "year": "2019",
    "agency": "ultranoir",
    "agencyUrl": "http://www.ultranoir.com/",
    "awards": [{
        "type": "FWA",
        "name": "Site of the day",
        "date": "24/02/2020"
    }]
}, {
    "title": "ultranoir#Website",
    "fullImage": "ultranoirv4.jpg",
    "tags": ["HTML5", "SASS", "JavaScript", "Vue.js", "Three.js", "GLSL", "GSAP"],
    "url": "http://www.ultranoir.com/",
    "year": "2019",
    "agency": "ultranoir",
    "agencyUrl": "http://www.ultranoir.com/",
    "awards": [{
        "type": "Awwwards",
        "name": "Site of the day",
        "date": "05/03/2019"
    }, {
        "type": "Awwwards",
        "name": "Developer awards",
        "date": "05/03/2019"
    }, {
        "type": "Awwwards",
        "name": "Mobile excellence awards",
        "date": "05/03/2019"
    }, {
        "type": "FWA",
        "name": "Site of the day",
        "date": "28/02/2019"
    }, {
        "type": "CSS Design Awards",
        "name": "Site of the day",
        "date": "05/03/2019"
    }]
}, {
    "title": "VIPPING#Website",
    "fullImage": "vipping.jpg",
    "tags": ["HTML5", "SASS", "JavaScript", "Browserify", "Gulp", "GSAP"],
    "url": "https://www.vipping.luxury/",
    "year": "2018",
    "agency": "ultranoir",
    "agencyUrl": "http://www.ultranoir.com/",
    "awards": []
}, {
    "title": "NATIXIS#Intranet",
    "fullImage": "natixis_intranet.png",
    "tags": ["HTML5", "SASS", "JavaScript", "Underscore.js"],
    "url": "https://www.ultranoir.com/fr/projets/anytime-1455.html",
    "year": "2017",
    "agency": "ultranoir",
    "agencyUrl": "http://www.ultranoir.com/",
    "awards": []
}, {
    "title": "École#multimedia",
    "fullImage": "ecoleMultimedia2.jpg",
    "tags": ["HTML5", "SASS", "JavaScript", "Browserify", "Gulp", "GSAP"],
    "url": "https://www.ecole-multimedia.com/",
    "year": "2016",
    "agency": "ultranoir",
    "agencyUrl": "http://www.ultranoir.com/",
    "awards": []
}, {
    "title": "Virtual#Reality",
    "fullImage": "vrUltranoir.jpg",
    "tags": ["HTML5", "SASS", "JavaScript", "Browserify", "Gulp", "GSAP"],
    "url": "http://vr.ultranoir.com/",
    "year": "2016",
    "agency": "ultranoir",
    "agencyUrl": "http://www.ultranoir.com/",
    "awards": [{
        "type": "Awwwards",
        "name": "Site of the day",
        "date": "25/05/2016"
    }, {
        "type": "CSS Awards",
        "name": "Site of the day",
        "date": "20/05/2016"
    }, {
        "type": "CSS Design Awards",
        "name": "Site of the day",
        "date": "26/05/2016"
    }]
}, {
    "title": "DIOR ADDICT#ULTRA-GLOSS",
    "fullImage": "diorUltraGlossApp.jpg",
    "tags": ["HTML5", "SASS", "React.js", "Cordova", "Gulp"],
    "url": "https://www.ultranoir.com/fr/projets/dior-addict-ultra-gloss-1436.html",
    "year": "2016",
    "agency": "ultranoir",
    "agencyUrl": "http://www.ultranoir.com/",
    "awards": []
}, {
    "title": "150 ans#Printemps",
    "fullImage": "printemps.jpg",
    "tags": ["HTML5", "SASS", "Vue.js", "Gulp", "GSAP"],
    "url": "https://vimeo.com/131560433",
    "year": "2015",
    "agency": "grouek",
    "agencyUrl": "http://grouek.com/",
    "awards": []
}, {
    "title": "Montres#Dewitt",
    "fullImage": "dewitt.jpg",
    "tags": ["HTML5", "CSS3", "Require.js", "GSAP", "Grunt", "Underscore.js"],
    "url": "http://www.dewitt.ch/",
    "year": "2014",
    "agency": "ultranoir",
    "agencyUrl": "http://www.ultranoir.com/",
    "awards": [{
        "type": "Awwwards",
        "name": "Site of the day",
        "date": "18/09/2014"
    }, {
        "type": "FWA",
        "name": "Site of the day",
        "date": "20/10/2014"
    }]
}];

/***/ }),

/***/ "L0Zd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/vuex-i18n/dist/vuex-i18n.es.js
var vuex_i18n_es = __webpack_require__("kmDT");

// CONCATENATED MODULE: ./src/translations/index.js
/* harmony default export */ var translations = ({
    en: {
        nav: {
            works: 'Works',
            about: 'About'
        },
        about: {
            title: 'About me',
            text1: "My name is Kévin Rousseau. I'm a <b>French Front-end Developer</b> based in <b>Paris, France</b>. Always fascinated by the code and graphics, I try to amalgamate the best of both in my projects. In my spare time, I realize works in 3D, and I'm interested in photography.",
            text2: "I've worked on projects for many clients like <b>Dior, Chanel, Diptyque, Valentino, Printemps, Comme des Garçons, Montblanc, OCS, Natixis, RATP, ...</b>",
            text3: 'I’m currently Front-End Developer <a href=\"http://www.ultranoir.com/\" target=\"_blank\" class=\"bold\">@ultranoir</a>.',
            text4: 'Previously <a href=\"http://www.grouek.com/\" target=\"_blank\" class=\"bold\">@Grouek</a>',
            text5: "For more informations about me, please ",
            text6: 'download my resume'
        },
        frontEnd: 'Front-End developer',
        "details": "Details",
        "close": "Close",
        projectsList: {
            0: {
                description: "Realization of the Mechant.tv website, creative post-production studio."
            },
            1: {
                description: "In this digital experience, you will discover paintings generated by AI, inspired by great master painters and based on the creative momentum of the ultranoir teams, you will walk through a room paying homage to Soulages, and will be able to produce your own pictorial works."
            },
            2: {
                description: "Realization of the Keakr website, a company that opens a new era in the field of music via its platform based on blockchain and web3. Composed of visual, 3D and video elements, it tends to show that Keakr is established in a universe based on technology and innovation."
            },
            3: {
                description: "Realization for the Moët Hennesy house, of the redesign of the new Cloudy Bay website, a famous New Zealand vineyard."
            },
            4: {
                description: "Designed by Montblanc, this veritable setting dedicated to writing, with a total surface area of ​​3,600m2, invites the visitor for a total immersion in the history of the house from its origins to the present day.<br/><br/>(Creation of multimedia experiences)."
            },
            5: {
                description: "Diptyque partners with American floral artist Maurice Harris for the new collection of its iconic fragrance Eau Rose"
            },
            6: {
                description: "Each Comme des Garçons fragrance is unique, just like those who wear it. It is by being guided by his 4 senses and emotions that the user answers the questions of the diagnosis. Throughout the experience, the user will see his or her own essence materialize, revealing the fragrance that corresponds to his or her personality.The experience is developed in Web GL, in order to dynamically generate unique and user-specific shapes. Shaders have also been created to measure in order to be as close as possible to the texture of each of the House's fragrances."
            },
            7: {
                description: "Redesign of the ultranoir agency website. Realization of Front development of the site. Full responsive version. (Desktop, tablet and mobile)"
            },
            8: {
                description: "Vipping, the world's first global private flying club. Realization of Front development of the site. Full responsive version. (Desktop, tablet and mobile)"
            },
            9: {
                description: "Internal time management tool to meet the new requirements of Natixis Group employees and managers.<br/><br/>The application won the title of DSI project of the month among 12 others submitted internally by Natixis Monde."
            },
            10: {
                description: "Realization of Front development of the site. Full responsive version. (Desktop, tablet and mobile)"
            },
            11: {
                description: 'Realization of Front development of the site.'
            },
            12: {
                description: "Present at the dealers of the brand, the application allows clients to access a real social network Dior: as they navigated, they were able to take pictures, customize their polaroid, send it By e-mail, AirDrop or even print it directly in-store."
            },
            13: {
                description: "Game competition organized for the 150 years of the famous Parisian shop: Printemps."
            },
            14: {
                description: 'Realization of Front development of the site.'
            }
        },
        notFound: "This page does not exist",
        update: {
            text1: "Update in progress",
            text2: "I'll be back, soon."
        }
    },
    fr: {
        nav: {
            works: 'Projets',
            about: 'A propos'
        },
        about: {
            title: 'A propos',
            text1: "Je m'appelle Kévin Rousseau. Je suis un <b>Développeur Front-End français</b>, basé à <b>Paris, France</b>. Depuis toujours fasciné par le code et le graphisme, j'essaye de fusionner les deux dans mes projets. À mes heures perdues, je réalise des créations en 3d et je pratique la photographie.",
            text2: "J'ai travaillé à travers divers projets, pour de nombreux clients tels que <b>Dior, Chanel, Diptyque, Valentino, Printemps, Comme des Garçons,  Montblanc, OCS, Natixis, RATP, ...</b>",
            text3: 'Actuellement Développeur Front-End <a href=\"http://www.ultranoir.com/\" target=\"_blank\" class=\"bold\">@ultranoir</a>.',
            text4: 'Précédement <a href=\"http://www.grouek.com/\" target=\"_blank\" class=\"bold\">@Grouek</a>',
            text5: "Pour plus d'informations à mon sujet, ",
            text6: 'téléchargez mon CV'
        },
        frontEnd: 'Développeur Front-End',
        "details": "Détails",
        "close": "Fermer",
        projectsList: {
            0: {
                description: "Réalisation du site de Mechant.tv, studio créatif de post-production."
            },
            1: {
                description: "Dans cette expérience digitale, vous découvrirez des tableaux générés par l'IA, inspirés de grands maîtres peintres et basés sur l'élan créatif des équipes d'ultranoir, vous parcourrez une salle rendant hommage à Soulages, et pourrez générer vos propres œuvres picturales."
            },
            2: {
                description: "Réalisation du site Keakr, entreprise qui ouvre une nouvelle ère dans le domaine de la musique via sa plateforme basée sur la blockchain et le web3. Composé d'éléments visuels, 3D et de vidéos il tend à montrer que Keakr est implanté dans un univers basé sur la technologie et l'innovation."
            },
            3: {
                description: "Réalisation pour la maison Moët Hennesy, de la refonte du nouveau site Cloudy Bay, célèbre vignoble Néo-Zelandais."
            },
            4: {
                description: "Imaginé par Montblanc, ce véritable écrin dédié à l'écriture, d'une surface totale de 3 600 m2, invite le visiteur à une immersion totale dans l'histoire de la maison de ses origines à nos jours.<br/><br/>(Création d'expériences multimédia)."
            },
            5: {
                description: "Diptyque s’associe avec l’artiste floral Américain Maurice Harris pour la nouvelle collection de son parfum iconique Eau Rose"
            },
            6: {
                description: "Chaque parfum Comme des Garçons est unique, tout comme ceux qui le portent. C’est en étant guidé par ses 4 sens et par ses émotions que l’utilisateur répond aux questions du diagnostic. Tout au long de l'expérience, l'utilisateur verra sa propre essence se matérialiser, pour révéler le parfum qui correspond à sa personnalité. L’expérience est développée en Web GL, afin de générer dynamiquement des formes uniques et propres à chaque utilisateur. Des shaders on aussi été crées sur mesure afin de se rapprocher au plus près de la texture de chaque parfum de la Maison."
            },
            7: {
                description: "Refonte du site de l'agence ultranoir. Réalisation du développement Front du site. Version full responsive. (Desktop, tablette et mobile)"
            },
            8: {
                description: "Vipping, nouvelle référence dans le transport aérien haut de gamme. Réalisation du développement Front du site. Version full responsive. (Desktop, tablette et mobile)"
            },
            9: {
                description: "Outil interne de gestion des temps pour répondre aux nouvelles exigences des collaborateurs et managers du groupe Natixis.<br/><br/>L’application a remporté le titre de projet DSI du mois parmi 12 autres soumis en interne par Natixis Monde."
            },
            10: {
                description: "Réalisation du développement Front du site. Version full responsive. (Desktop, tablette et mobile)"
            },
            11: {
                description: 'Réalisation du développement Front du site.'
            },
            12: {
                description: "Présente chez les revendeurs de la marque, l'application permet aux clientes d'accéder à un vrai réseau social Dior : au fur et à mesure de la navigation, ces dernières ont pu se prendre en photo, customiser leur polaroïd, se l'envoyer par e-mail, AirDrop ou même l'imprimer directement en magasin."
            },
            13: {
                description: "Jeu concours organisé pour les 150 ans du célèbre magasin Parisien : Printemps."
            },
            14: {
                description: 'Réalisation du développement Front du site.'
            }
        },
        notFound: "Cette page n'existe pas",
        update: {
            text1: "Mise à jour en cours",
            text2: "Je reviens vite."
        }
    }
});
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/gsap/index.js + 10 modules
var gsap = __webpack_require__("R5/K");

// EXTERNAL MODULE: ./node_modules/rellax/rellax.js
var rellax = __webpack_require__("bioz");
var rellax_default = /*#__PURE__*/__webpack_require__.n(rellax);

// EXTERNAL MODULE: ./src/components/Projects/projects.js
var projects = __webpack_require__("I2Ij");
var projects_default = /*#__PURE__*/__webpack_require__.n(projects);

// EXTERNAL MODULE: ./node_modules/pixi.js/lib/index.js
var lib = __webpack_require__("50uv");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FluidBackground/FluidBackground.vue
//
//
//
//



/* harmony default export */ var FluidBackground = ({
    name: 'FluidBackground',
    props: ['image', 'name'],
    data: function data() {
        return {};
    },

    mounted: function mounted() {
        this.setCanvas();
        this.resizeTimer;
        window.addEventListener('resize', this.resize);
    },
    methods: {
        resize: function resize() {
            var _this = this;

            clearTimeout(this.resizeTimer);
            this.resizeTimer = setTimeout(function (_) {
                _this.destroyCanvas();
                setTimeout(_this.setCanvas, 0);
            }, 250);
        },
        backgroundCover: function backgroundCover(bgSize, inputSprite, type, forceSize) {
            var sprite = inputSprite;
            var bgContainer = new lib["Container"]();
            var mask = new lib["Graphics"]().beginFill(0x8bc5ff).drawRect(0, 0, bgSize.x, bgSize.y).endFill();
            bgContainer.mask = mask;
            bgContainer.addChild(mask);
            bgContainer.addChild(sprite);

            var sp = { x: sprite.width, y: sprite.height };
            if (forceSize) sp = forceSize;
            var winratio = bgSize.x / bgSize.y;
            var spratio = sp.x / sp.y;
            var scale = 1;
            var pos = new lib["Point"](0, 0);
            if (type == 'cover' ? winratio > spratio : winratio < spratio) {
                //photo is wider than background
                scale = bgSize.x / sp.x;
                pos.y = -(sp.y * scale - bgSize.y) / 2;
            } else {
                //photo is taller than background
                scale = bgSize.y / sp.y;
                pos.x = -(sp.x * scale - bgSize.x) / 2;
            }

            sprite.scale = new lib["Point"](scale, scale);
            sprite.position = pos;

            return bgContainer;
        },
        setCanvas: function setCanvas() {
            var _this2 = this;

            // disable PIXI console message
            lib["utils"].skipHello();

            var renderer = new lib["autoDetectRenderer"](this.$refs.canvasWrapper.offsetWidth, this.$refs.canvasWrapper.offsetHeight, { transparent: true });

            this.$refs.canvasWrapper.innerHTML = '';
            this.$refs.canvasWrapper.appendChild(renderer.view);

            renderer.autoResize = true;
            this.renderer = renderer;

            var stage = new lib["Container"]();
            this.stage = stage;
            stage.interactive = true;

            // displacement -----
            var displacementSprite = lib["Sprite"].fromImage(__webpack_require__("fxmc"));
            var displacementFilter = new lib["filters"].DisplacementFilter(displacementSprite);

            this.displacementFilter = displacementFilter;

            displacementSprite.texture.baseTexture.wrapMode = lib["WRAP_MODES"].REPEAT;

            stage.filters = [displacementFilter];

            displacementFilter.scale.x = 0;
            displacementFilter.scale.y = 0;

            stage.addChild(displacementSprite);

            var imageSrc = this.image,
                loader = new lib["loaders"].Loader();

            loader.add(this.name, imageSrc);
            loader.load(function (loader, resources) {

                _this2.setImage(resources);

                var render = new lib["ticker"].Ticker();
                render.autoStart = true;
                _this2.render = render;

                render.add(function (delta) {
                    renderer.render(stage);
                });
            });

            this.loader = loader;
        },
        setImage: function setImage(resources) {
            for (var i = this.stage.children.length - 1; i >= 0; i--) {
                this.stage.removeChild(this.stage.children[i]);
            }var texture = resources ? resources[this.name].texture : this.loader.resources[this.name].texture,
                image = this.backgroundCover({ x: this.$refs.canvasWrapper.offsetWidth, y: this.$refs.canvasWrapper.offsetHeight }, new lib["Sprite"](texture), 'cover');

            this.stage.addChild(image);
        },
        toggleDisplacement: function toggleDisplacement(displace) {
            var xVal,
                yVal,
                displacementFilter = this.displacementFilter;

            if (displace) {
                xVal = -30;
                yVal = -25;
                TweenMax.to(displacementFilter.scale, 0.5, { x: "+=" + Math.sin(xVal) * 1200 + "", y: "+=" + Math.cos(yVal) * 200 + "" });
            } else {
                TweenMax.to(displacementFilter.scale, 0.5, { x: 0, y: 0 });
            }
        },
        destroyCanvas: function destroyCanvas() {
            this.stage.destroy(true);
            this.stage = null;
            this.$refs.canvasWrapper.removeChild(this.renderer.view);
            this.renderer.destroy(true);
            this.renderer = null;
        }
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('resize', this.resize);
        this.destroyCanvas();
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52f21c92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FluidBackground/FluidBackground.vue
var FluidBackground_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"canvasWrapper",staticClass:"FluidBackground"})}
var staticRenderFns = []
var esExports = { render: FluidBackground_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var FluidBackground_FluidBackground = (esExports);
// CONCATENATED MODULE: ./src/components/FluidBackground/FluidBackground.vue
function injectStyle (ssrContext) {
  __webpack_require__("L0Zd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FluidBackground,
  FluidBackground_FluidBackground,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_FluidBackground_FluidBackground = (Component.exports);

// EXTERNAL MODULE: ./node_modules/perfect-scrollbar/dist/perfect-scrollbar.esm.js
var perfect_scrollbar_esm = __webpack_require__("HMpe");

// EXTERNAL MODULE: ./node_modules/mobile-detect/mobile-detect.js
var mobile_detect = __webpack_require__("UMwo");
var mobile_detect_default = /*#__PURE__*/__webpack_require__.n(mobile_detect);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Project/Project.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var _require = __webpack_require__("+9Dj"),
    detect = _require.detect;

/* harmony default export */ var Project = ({
    name: 'Project',
    data: function data() {
        return {
            p: this.datas.p,
            description: 'projectsList.' + this.index.index + '.description',
            isMobile: true,
            isIe: false,
            isSafari: false
        };
    },

    components: {
        FluidBackground: components_FluidBackground_FluidBackground
    },
    props: ['datas', 'index'],
    mounted: function mounted() {
        this.customScroll = new perfect_scrollbar_esm["a" /* default */](this.$refs.scrollableContent, {
            suppressScrollX: true,
            maxScrollbarLength: 300
        });

        var md = new mobile_detect_default.a(window.navigator.userAgent);
        this.isMobile = md.mobile();

        var browser = detect();
        this.isIe = browser.name == 'ie' || browser.name == 'edge';
        this.isSafari = browser.name == 'safari' || browser.name == 'ios';
    },
    computed: {
        setTitle: function setTitle() {
            var title = this.p.title,
                words = title.split('#');

            if (words.length > 1) {
                return '<span class="titleLineWrapper">\n                            <span class="titleLine firstLine">' + words[0] + '</span>\n                            </span><span class="titleLineWrapper">\n                                <span class="titleLine lastLine">' + words[1] + '</span>\n                            </span>';
            } else {
                return '<span class="titleLineWrapper">\n                            <span class="titleLine firstLine">' + words[0] + '</span>\n                            </span>';
            }
        },
        setProjectNumber: function setProjectNumber() {
            var number = parseInt(this.index.index, 10);
            return number >= 10 ? number + 1 : '0' + (number + 1);
        },
        setDescriptionTitle: function setDescriptionTitle() {
            return this.p.title.replace('#', ' ');
        }
    },
    methods: {
        showDescription: function showDescription(e) {
            var _this = this;

            e.preventDefault();

            var project = this.$refs.wrapper,
                descriptionWrapper = project.querySelector('.projectFullInfos'),
                secondBg = project.querySelector('.secondBg'),
                projectTitle = descriptionWrapper.querySelector('h3'),
                description = descriptionWrapper.querySelector('.description'),
                infosList = descriptionWrapper.querySelectorAll('.infos'),
                tags = descriptionWrapper.querySelector('.projectTags'),
                awards = descriptionWrapper.querySelectorAll('.projectAwards li'),
                openBtn = project.querySelector('.openDescriptionBtn'),
                openText = openBtn.querySelector('.open'),
                closeText = openBtn.querySelector('.close');

            if (!descriptionWrapper.classList.contains('open')) {

                if (!this.isMobile && !this.isIe) this.$refs.fluidBackground.toggleDisplacement(true);

                gsap["a" /* TweenMax */].to(descriptionWrapper, 0.3, { width: '50%', force3D: true, ease: Power2.easeOut });
                gsap["a" /* TweenMax */].to(secondBg, 0.3, { width: '100%', delay: 0.1, ease: Power2.easeOut, onComplete: function onComplete(_) {
                        gsap["a" /* TweenMax */].staggerTo([projectTitle, infosList, description, tags], 0.3, { y: 0, autoAlpha: 1, ease: Power2.easeOut }, 0.1, function (_) {
                            gsap["a" /* TweenMax */].staggerTo(awards, 0.3, { y: 0, autoAlpha: 1, ease: Power2.easeOut }, 0.1);
                        });

                        descriptionWrapper.classList.add('open');
                        _this.customScroll.update();
                    } });

                gsap["a" /* TweenMax */].staggerTo(project.querySelectorAll('.titleLine'), 0.3, { y: '100%', ease: Power2.easeOut }, 0.05);

                gsap["a" /* TweenMax */].to(openText, 0.5, { top: -100, autoAlpha: 0 });
                gsap["a" /* TweenMax */].to(closeText, 0.5, { top: 20, autoAlpha: 1 });
            } else {
                gsap["a" /* TweenMax */].staggerTo([projectTitle, infosList, description, tags, awards], 0.3, { y: 10, autoAlpha: 0, ease: Power2.easeOut }, 0.1, function (_) {
                    gsap["a" /* TweenMax */].to(secondBg, 0.3, { width: 0, ease: Power2.easeOut });

                    if (!_this.isMobile && !_this.isIe) _this.$refs.fluidBackground.toggleDisplacement(false);

                    gsap["a" /* TweenMax */].to(descriptionWrapper, 0.3, { width: 0, force3D: true, delay: 0.1, ease: Power2.easeOut, onComplete: function onComplete(_) {

                            gsap["a" /* TweenMax */].staggerTo(project.querySelectorAll('.titleLine'), 0.3, { y: '0%', ease: Power2.easeOut }, 0.05);

                            descriptionWrapper.classList.remove('open');
                        } });
                });

                gsap["a" /* TweenMax */].to(openText, 0.5, { top: 20, autoAlpha: 1 });
                gsap["a" /* TweenMax */].to(closeText, 0.5, { top: 100, autoAlpha: 0 });
            }
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.customScroll.destroy();
        this.customScroll = null;
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9355b91c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Project/Project.vue
var Project_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"projectSlide"},[_c('div',{ref:"wrapper",staticClass:"projectWrapper"},[_c('a',{attrs:{"href":_vm.p.url,"target":"_blank"}},[_c('div',{staticClass:"projectBgWrapper"},[_c('div',{staticClass:"projectBgScale rellax",attrs:{"data-rellax-speed":"-2"}},[_c('div',{staticClass:"projectBg",style:({'background-image': ("url(" + (__webpack_require__("/zTL")("./"+_vm.p.fullImage)) + ")")})}),_vm._v(" "),(!_vm.isMobile && !_vm.isIe)?_c('FluidBackground',{ref:"fluidBackground",attrs:{"image":__webpack_require__("/zTL")("./"+_vm.p.fullImage),"name":_vm.p.title}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"openDescriptionBtn",on:{"click":_vm.showDescription}},[_c('div',{staticClass:"open"},[_c('span',{staticClass:"icon-info"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('details')))])]),_vm._v(" "),_c('div',{staticClass:"close"},[_c('span',{staticClass:"icon-close"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('close')))])])]),_vm._v(" "),_c('div',{staticClass:"projectInfos rellax",attrs:{"data-rellax-speed":_vm.isSafari ? 0 : 2.5}},[_c('h2',{staticClass:"projectTitle",domProps:{"innerHTML":_vm._s(_vm.setTitle)}}),_vm._v(" "),_c('div',{staticClass:"projectNumber"},[_vm._v(_vm._s(_vm.setProjectNumber))])])]),_vm._v(" "),_c('div',{staticClass:"projectFullInfos"},[_c('div',{staticClass:"secondBg"}),_vm._v(" "),_c('div',{ref:"scrollableContent",staticClass:"scrollableContent"},[_c('div',{staticClass:"content"},[_c('h3',{domProps:{"innerHTML":_vm._s(_vm.setDescriptionTitle)}}),_vm._v(" "),_c('ul',{staticClass:"infos"},[_c('li',[_vm._v(_vm._s(_vm.p.year))]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":_vm.p.agencyUrl,"target":"_blank"}},[_vm._v(_vm._s(_vm.p.agency))])]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t('frontEnd')))])]),_vm._v(" "),_c('p',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.$t(_vm.description))}}),_vm._v(" "),_c('ul',{staticClass:"projectTags"},[_vm._l((_vm.p.tags),function(tag,i){return [(i == (_vm.p.tags.length-1))?_c('li',[_vm._v(_vm._s(tag))]):_c('li',[_vm._v(_vm._s(tag)+" - ")])]})],2),_vm._v(" "),_c('ul',{staticClass:"projectAwards"},_vm._l((_vm.p.awards),function(award,i){return _c('li',[_c('span',{staticClass:"awardType"},[_vm._v(_vm._s(award.type))]),_vm._v(" - "+_vm._s(award.name)+" ("+_vm._s(award.date)+")\n                        ")])}))])])])]),_vm._v(" "),(_vm.index.index === 0)?_c('span',{staticClass:"scrollIndicator icon-keyboard_arrow_down"}):_vm._e()])}
var Project_staticRenderFns = []
var Project_esExports = { render: Project_render, staticRenderFns: Project_staticRenderFns }
/* harmony default export */ var Project_Project = (Project_esExports);
// CONCATENATED MODULE: ./src/components/Project/Project.vue
function Project_injectStyle (ssrContext) {
  __webpack_require__("lvNC")
}
var Project_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Project___vue_template_functional__ = false
/* styles */
var Project___vue_styles__ = Project_injectStyle
/* scopeId */
var Project___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Project___vue_module_identifier__ = null
var Project_Component = Project_normalizeComponent(
  Project,
  Project_Project,
  Project___vue_template_functional__,
  Project___vue_styles__,
  Project___vue_scopeId__,
  Project___vue_module_identifier__
)

/* harmony default export */ var components_Project_Project = (Project_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Projects/Projects.vue
//
//
//
//
//
//
//
//







/* harmony default export */ var Projects = ({
    name: 'Projects',
    data: function data() {
        return {
            projectsList: projects_default.a,
            isScrolling: false
        };
    },

    components: {
        Project: components_Project_Project
    },
    mounted: function mounted() {
        this.showPage();
        window.addEventListener('resize', this.setParallax);
        window.addEventListener('scroll', this.hideScrollIndicator);
    },
    methods: {
        setParallax: function setParallax() {
            if (this.rellaxEvt) this.rellaxEvt.destroy();

            this.rellaxEvt = new rellax_default.a('.rellax', {
                center: true
            });
        },
        showPage: function showPage() {
            var _this = this;

            gsap["a" /* TweenMax */].to(this.$el.querySelectorAll('.projectSlide'), 0.8, { opacity: 1, y: 0, delay: 0.8, ease: Power2.easeOut, onComplete: function onComplete(_) {
                    _this.setParallax();
                    gsap["a" /* TweenMax */].to(document.querySelectorAll('.firstLine'), 0.5, { y: 0, ease: Power2.easeOut });
                    gsap["a" /* TweenMax */].to(document.querySelectorAll('.lastLine'), 0.5, { y: 0, ease: Power2.easeOut, delay: 0.1 });
                    gsap["a" /* TweenMax */].to(document.querySelectorAll('.projectNumber'), 0.6, { x: 0, opacity: 1, ease: Power2.easeOut });
                    gsap["a" /* TweenMax */].to(document.querySelector('.scrollIndicator'), 0.5, { autoAlpha: 1 });
                } });
        },
        hideScrollIndicator: function hideScrollIndicator() {
            if (this.isScrolling) return;

            this.isScrolling = true;
            gsap["a" /* TweenMax */].to(document.querySelector('.scrollIndicator'), 0.5, { autoAlpha: 0 });
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        var _this2 = this;

        gsap["a" /* TweenMax */].to(document.querySelectorAll('.projectNumber'), 0.8, { x: '50%', opacity: 0, ease: Power2.easeOut });
        gsap["a" /* TweenMax */].to(document.querySelectorAll('.lastLine'), 0.6, { y: '120%', ease: Power2.easeOut, delay: 0.1 });
        gsap["a" /* TweenMax */].to(document.querySelectorAll('.firstLine'), 0.6, { y: '120%', ease: Power2.easeOut, onComplete: function onComplete(_) {
                // TweenMax.to(this.$el.querySelector('.fullBg'), 1, {background: '#161616'})
                gsap["a" /* TweenMax */].staggerTo(_this2.$el.querySelectorAll('.projectSlide'), 1, { opacity: 0, y: -200, ease: Quint.easeOut }, 0.2, next);
            } });
    },

    beforeDestroy: function beforeDestroy() {
        this.rellaxEvt.destroy();
        window.removeEventListener('resize', this.setParallax);
        window.addEventListener('scroll', this.hideScrollIndicator);
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c394afc0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Projects/Projects.vue
var Projects_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"projectsList"},[_vm._l((_vm.projectsList),function(p,index){return [_c('Project',{attrs:{"datas":{p: p},"index":{index: index}}})]})],2)}
var Projects_staticRenderFns = []
var Projects_esExports = { render: Projects_render, staticRenderFns: Projects_staticRenderFns }
/* harmony default export */ var Projects_Projects = (Projects_esExports);
// CONCATENATED MODULE: ./src/components/Projects/Projects.vue
function Projects_injectStyle (ssrContext) {
  __webpack_require__("PK+8")
}
var Projects_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Projects___vue_template_functional__ = false
/* styles */
var Projects___vue_styles__ = Projects_injectStyle
/* scopeId */
var Projects___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Projects___vue_module_identifier__ = null
var Projects_Component = Projects_normalizeComponent(
  Projects,
  Projects_Projects,
  Projects___vue_template_functional__,
  Projects___vue_styles__,
  Projects___vue_scopeId__,
  Projects___vue_module_identifier__
)

/* harmony default export */ var components_Projects_Projects = (Projects_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/About/About.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var About = ({
    name: 'About',
    data: function data() {
        return {};
    },

    mounted: function mounted() {
        gsap["a" /* TweenMax */].staggerTo(this.$refs.aboutPage.querySelectorAll('.animated'), 0.5, { opacity: 1, y: 0 }, 0.08);
    },
    methods: {
        cleanMail: function cleanMail(e) {
            var target = e.currentTarget,
                url = target.getAttribute('href'),
                newUrl = url.replace('|%/+at%$|', '@');

            target.setAttribute('href', newUrl);
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        gsap["a" /* TweenMax */].staggerTo(this.$refs.aboutPage.querySelectorAll('.animated'), 0.5, { opacity: 0, y: -100 }, 0.08, next);
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6ea8ee4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/About/About.vue
var About_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"aboutPage",staticClass:"aboutPage"},[_c('div',{staticClass:"aboutDescWrapper"},[_c('h2',{staticClass:"aboutTitle animated"},[_vm._v(_vm._s(_vm.$t('about.title')))]),_vm._v(" "),_c('p',{staticClass:"text animated",domProps:{"innerHTML":_vm._s(_vm.$t('about.text1'))}}),_vm._v(" "),_c('p',{staticClass:"text animated",domProps:{"innerHTML":_vm._s(_vm.$t('about.text2'))}}),_vm._v(" "),_c('p',{staticClass:"text animated"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('about.text3'))}}),_c('br'),_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('about.text4'))}})]),_vm._v(" "),_c('p',{staticClass:"text animated"},[_vm._v("\n            "+_vm._s(_vm.$t('about.text5'))+" "),(this.$i18n.locale() == 'fr')?_c('a',{staticClass:"bold",attrs:{"href":__webpack_require__("u+oR"),"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('about.text6')))]):_c('a',{staticClass:"bold",attrs:{"href":__webpack_require__("A4Sc"),"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('about.text6')))]),_vm._v(".\n        ")]),_vm._v(" "),_c('ul',{staticClass:"linksList"},[_c('li',{staticClass:"animated"},[_c('a',{staticClass:"mail icon-envelope",attrs:{"href":"mailto:hello|%/+at%$|kevinrousseau.com"},on:{"click":_vm.cleanMail}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)])])])}
var About_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"animated"},[_c('a',{staticClass:"icon-linkedin",attrs:{"href":"https://www.linkedin.com/in/kévin-rousseau-20983381/","target":"_blank"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"animated"},[_c('a',{staticClass:"icon-github",attrs:{"href":"https://github.com/kevrou","target":"_blank"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"animated"},[_c('a',{staticClass:"icon-twitter",attrs:{"href":"https://twitter.com/kevRousseau","target":"_blank"}})])}]
var About_esExports = { render: About_render, staticRenderFns: About_staticRenderFns }
/* harmony default export */ var About_About = (About_esExports);
// CONCATENATED MODULE: ./src/components/About/About.vue
function About_injectStyle (ssrContext) {
  __webpack_require__("CUSo")
}
var About_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var About___vue_template_functional__ = false
/* styles */
var About___vue_styles__ = About_injectStyle
/* scopeId */
var About___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var About___vue_module_identifier__ = null
var About_Component = About_normalizeComponent(
  About,
  About_About,
  About___vue_template_functional__,
  About___vue_styles__,
  About___vue_scopeId__,
  About___vue_module_identifier__
)

/* harmony default export */ var components_About_About = (About_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NotFound/NotFound.vue
//
//
//
//
//
//

/* harmony default export */ var NotFound = ({
    name: 'NotFound',
    data: function data() {
        return {};
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3eb51eb6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotFound/NotFound.vue
var NotFound_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notFoundPage"},[_c('p',{staticClass:"text"},[_c('span',[_vm._v("Oups")]),_c('br'),_vm._v(_vm._s(_vm.$t('notFound')))])])}
var NotFound_staticRenderFns = []
var NotFound_esExports = { render: NotFound_render, staticRenderFns: NotFound_staticRenderFns }
/* harmony default export */ var NotFound_NotFound = (NotFound_esExports);
// CONCATENATED MODULE: ./src/components/NotFound/NotFound.vue
function NotFound_injectStyle (ssrContext) {
  __webpack_require__("XsJc")
}
var NotFound_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NotFound___vue_template_functional__ = false
/* styles */
var NotFound___vue_styles__ = NotFound_injectStyle
/* scopeId */
var NotFound___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NotFound___vue_module_identifier__ = null
var NotFound_Component = NotFound_normalizeComponent(
  NotFound,
  NotFound_NotFound,
  NotFound___vue_template_functional__,
  NotFound___vue_styles__,
  NotFound___vue_scopeId__,
  NotFound___vue_module_identifier__
)

/* harmony default export */ var components_NotFound_NotFound = (NotFound_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js







vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

var router = new vue_router_esm["a" /* default */]({
    routes: [{
        path: '/',
        name: 'Projects',
        component: components_Projects_Projects
    }, {
        path: '/about',
        name: 'About',
        component: components_About_About
    }, {
        path: '*',
        name: 'NotFound',
        component: components_NotFound_NotFound
    }]
});

/* harmony default export */ var src_router = (router);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Preloader/Preloader.vue
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Preloader = ({
    name: 'Preloader',
    data: function data() {
        return {
            percent: 0
        };
    },

    mounted: function mounted() {
        var _this = this;

        var images = [];

        for (var i = 0; i < projects_default.a.length; i++) {
            images.push(projects_default.a[i].fullImage);
        }this.preloadImages(images, function (_) {
            setTimeout(function (_) {
                _this.$emit('updateLoaderState');
            }, 500);
        });
    },
    methods: {
        preloadImages: function preloadImages(sources, callback) {
            var _this2 = this;

            // load all images in this virtualEl
            var imgs = [],
                img,
                remaining = sources.length;

            for (var i = 0; i < sources.length; i++) {
                img = new Image();
                imgs.push(img);

                img.onload = function (_) {
                    remaining--;

                    var percent = (sources.length - remaining) / sources.length;
                    _this2.percent = Math.round(percent * 100);

                    gsap["a" /* TweenMax */].to(_this2.$refs.percentBar, 0.3, { width: _this2.percent + '%' });

                    if (remaining == 0) callback();
                };

                img.onerror = function (error) {
                    console.error('Preload error with this image : ' + error.path[0].src);
                    remaining--;
                };

                img.src = __webpack_require__("/zTL")("./" + sources[i]);
            }

            if (remaining === 0) callback();
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c7ffc5b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Preloader/Preloader.vue
var Preloader_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preloadPage"},[_c('div',{staticClass:"preloadWrapper"},[_c('div',{staticClass:"percentBar"},[_c('div',{ref:"percentBar"})]),_vm._v(" "),_c('p',{staticClass:"percent"},[_vm._v(_vm._s(_vm.percent)+"%")])])])}
var Preloader_staticRenderFns = []
var Preloader_esExports = { render: Preloader_render, staticRenderFns: Preloader_staticRenderFns }
/* harmony default export */ var Preloader_Preloader = (Preloader_esExports);
// CONCATENATED MODULE: ./src/components/Preloader/Preloader.vue
function Preloader_injectStyle (ssrContext) {
  __webpack_require__("g9lV")
}
var Preloader_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Preloader___vue_template_functional__ = false
/* styles */
var Preloader___vue_styles__ = Preloader_injectStyle
/* scopeId */
var Preloader___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Preloader___vue_module_identifier__ = null
var Preloader_Component = Preloader_normalizeComponent(
  Preloader,
  Preloader_Preloader,
  Preloader___vue_template_functional__,
  Preloader___vue_styles__,
  Preloader___vue_scopeId__,
  Preloader___vue_module_identifier__
)

/* harmony default export */ var components_Preloader_Preloader = (Preloader_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MainNav/MainNav.vue
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var MainNav = ({
    name: 'MainNav',
    data: function data() {
        return {};
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d90763a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainNav/MainNav.vue
var MainNav_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"mainNav"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.$t('nav.works')))])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/about"}},[_vm._v(_vm._s(_vm.$t('nav.about')))])],1)])])}
var MainNav_staticRenderFns = []
var MainNav_esExports = { render: MainNav_render, staticRenderFns: MainNav_staticRenderFns }
/* harmony default export */ var MainNav_MainNav = (MainNav_esExports);
// CONCATENATED MODULE: ./src/components/MainNav/MainNav.vue
function MainNav_injectStyle (ssrContext) {
  __webpack_require__("vn2E")
}
var MainNav_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MainNav___vue_template_functional__ = false
/* styles */
var MainNav___vue_styles__ = MainNav_injectStyle
/* scopeId */
var MainNav___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MainNav___vue_module_identifier__ = null
var MainNav_Component = MainNav_normalizeComponent(
  MainNav,
  MainNav_MainNav,
  MainNav___vue_template_functional__,
  MainNav___vue_styles__,
  MainNav___vue_scopeId__,
  MainNav___vue_module_identifier__
)

/* harmony default export */ var components_MainNav_MainNav = (MainNav_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ToggleLanguage/ToggleLanguage.vue
//
//
//
//
//
//
//

/* harmony default export */ var ToggleLanguage = ({
    name: 'ToggleLanguage',
    methods: {
        changeLang: function changeLang(e) {
            var target = e.currentTarget;
            this.$refs.navLang.querySelector('.active').classList.remove('active');
            target.classList.add('active');
            this.$i18n.set(target.getAttribute('data-lang'));
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21e65a5b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ToggleLanguage/ToggleLanguage.vue
var ToggleLanguage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{ref:"navLang",staticClass:"lang"},[_c('li',{staticClass:"active",attrs:{"data-lang":"fr"},on:{"click":_vm.changeLang}},[_vm._v("fr")]),_vm._v(" "),_c('li',{attrs:{"data-lang":"en"},on:{"click":_vm.changeLang}},[_vm._v("en")])])}
var ToggleLanguage_staticRenderFns = []
var ToggleLanguage_esExports = { render: ToggleLanguage_render, staticRenderFns: ToggleLanguage_staticRenderFns }
/* harmony default export */ var ToggleLanguage_ToggleLanguage = (ToggleLanguage_esExports);
// CONCATENATED MODULE: ./src/components/ToggleLanguage/ToggleLanguage.vue
function ToggleLanguage_injectStyle (ssrContext) {
  __webpack_require__("x+ts")
}
var ToggleLanguage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ToggleLanguage___vue_template_functional__ = false
/* styles */
var ToggleLanguage___vue_styles__ = ToggleLanguage_injectStyle
/* scopeId */
var ToggleLanguage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ToggleLanguage___vue_module_identifier__ = null
var ToggleLanguage_Component = ToggleLanguage_normalizeComponent(
  ToggleLanguage,
  ToggleLanguage_ToggleLanguage,
  ToggleLanguage___vue_template_functional__,
  ToggleLanguage___vue_styles__,
  ToggleLanguage___vue_scopeId__,
  ToggleLanguage___vue_module_identifier__
)

/* harmony default export */ var components_ToggleLanguage_ToggleLanguage = (ToggleLanguage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var App__require = __webpack_require__("+9Dj"),
    App_detect = App__require.detect;

/* harmony default export */ var App = ({
    name: 'app',
    data: function data() {
        return {
            isLoaded: false,
            isIe: false
        };
    },

    components: {
        Preloader: components_Preloader_Preloader,
        MainNav: components_MainNav_MainNav,
        ToggleLanguage: components_ToggleLanguage_ToggleLanguage
    },
    mounted: function mounted() {
        var browser = App_detect();
        this.isIe = browser.name == 'ie' || browser.name == 'edge' ? 'ie' : false;
    },
    methods: {
        updateLoaderState: function updateLoaderState() {
            var _this = this;

            this.isLoaded = true;

            setTimeout(function (_) {
                gsap["a" /* TweenMax */].to([_this.$refs.logo, document.querySelector('.mainNav'), document.querySelector('.lang')], 1.2, { autoAlpha: 1 });
            }, 0);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be43dd64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.isIe,attrs:{"id":"app"}},[_vm._m(0),_vm._v(" "),(!_vm.isLoaded)?_c('Preloader',{on:{"updateLoaderState":_vm.updateLoaderState}}):[_c('div',{ref:"logo",staticClass:"logoWrapper"},[_c('router-link',{attrs:{"to":"/"}},[_c('h1',{staticClass:"logo"},[_vm._v("Kévin Rousseau")])])],1),_vm._v(" "),_c('MainNav'),_vm._v(" "),_c('ToggleLanguage'),_vm._v(" "),_c('router-view')]],2)}
var App_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"linesBg"},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])}]
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("Cidb")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

// load vuex i18n module ---------



// for IE11
__webpack_require__("hKoQ").polyfill();

var store = new vuex_esm["a" /* default */].Store();
vue_esm["a" /* default */].use(vuex_i18n_es["a" /* default */].plugin, store);

vue_esm["a" /* default */].i18n.add('en', translations.en);
vue_esm["a" /* default */].i18n.add('fr', translations.fr);

vue_esm["a" /* default */].i18n.set('fr');

// -------------------------------



vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
    router: src_router,
    store: store,
    el: '#app',
    template: '<App/>',
    components: { App: src_App }
});

/***/ }),

/***/ "PK+8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PhY9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cdg.cab6d67.png";

/***/ }),

/***/ "Pl3I":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mechant.b05435a.jpg";

/***/ }),

/***/ "S684":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/keakr.1dc6682.jpg";

/***/ }),

/***/ "Vl6e":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/vipping.243eb2c.jpg";

/***/ }),

/***/ "WIpY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/vrUltranoir.7f376ce.jpg";

/***/ }),

/***/ "XsJc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y2H9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cloudyBay.fd6f54d.png";

/***/ }),

/***/ "bNfy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ultranoirv4.497af16.jpg";

/***/ }),

/***/ "fxmc":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/clouds.e9c5ba5.jpg";

/***/ }),

/***/ "g9lV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kNu9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/printemps.e21adf1.jpg";

/***/ }),

/***/ "lvNC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q2qx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/montblanc_haus.d7e2272.png";

/***/ }),

/***/ "tzh/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ecoleMultimedia2.90c0727.jpg";

/***/ }),

/***/ "u+oR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cv_rousseau_kevin_fr.3b353af.pdf";

/***/ }),

/***/ "vn2E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x+ts":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yafy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/natixis_intranet.bfcc248.png";

/***/ }),

/***/ "ynRJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/diorUltraGlossApp.3399361.jpg";

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.bc67c2a4270d5967f436.js